import { post } from '@/lib/request/index';
import { govern } from '../apiConstants';

// 获取闪送服务规则信息
export const getEntregaRules = function (param) {
  return post(govern.ENTREGA_RULES, { param });
};

// 获取闪送服务规则信息
export const entregaOrderCancel = function (param) {
  return post(govern.ENTREGA_ORDER_CANCEL, { param });
};

// 获取闪送服务规则信息
export const entregaOrderPreCancel = function (param) {
  return post(govern.ENTREGA_ORDER_PRE_CANCEL, { param });
};
